import { useEventHub } from '@satellite/composables/useEventHub';

export default useEventHub;
